export default __webpack_public_path__ + "static/media/startButton.443f76d6.svg";